import {
  RefundReason,
  RefundType,
  TransactionType,
} from '@Encore-FastStartup-Phase-Out/encore-shared';

import { endpoints } from '../constants/endpoints';
import { UpdateOrderDto } from '../constants/types';

import { BaseApi } from './index';

export class TransactionApi extends BaseApi<any> {
  constructor() {
    super(endpoints.transactions.base);
  }

  async getOrderWithTransactions(id: string) {
    return this.get(endpoints.transactions.orderTransactions(id));
  }

  async getOrderRefundRemaining(id: string, type: RefundType) {
    return this.get(endpoints.transactions.orderRefundRemaining(id, type));
  }

  async refundOrder(
    id: string,
    refundReason: RefundReason,
    refundType: RefundType,
    amount?: number,
  ) {
    const payload: any = {
      refundReason,
      refundType,
    };

    if (refundType !== RefundType.ProcessingFee && amount !== undefined) {
      payload.amount = amount;
    }

    return this.post(endpoints.transactions.orderRefund(id), payload);
  }

  async updateOrder(id: string, updateOrderDto: UpdateOrderDto) {
    return this.patch(endpoints.transactions.autoPayout(id), updateOrderDto);
  }

  async makeOrderPayout(id: string) {
    return this.post(endpoints.transactions.orderPayout(id));
  }

  async createCreditTransaction(amount: number, transactionType: TransactionType) {
    return this.post(endpoints.transactions.createAdminTransaction, {
      amount,
      transactionType,
    });
  }
}
